import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {CompanyProps} from '../types';
import companiesKeys from '../util/companies-keys';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import {UserProps} from 'modules/users/types';

const useEditCompanyAvailability = () => {
  const {accessControl} = useAccessControls();
  const {setData, getData} = useQueryHelpers();

  const onSuccess = (data: CompanyProps) => {
    setData(companiesKeys.details(accessControl!.companyId!), data);
    const profile = getData<UserProps>('/users/me');

    if (!profile) return;

    setData('/users/me', {
      ...profile,
      accessControls: profile.accessControls.map((someAccessControl) =>
        someAccessControl.id === accessControl?.id
          ? {...someAccessControl, company: data}
          : someAccessControl,
      ),
    });
  };

  return useApiMutation({
    url: `/companies/${accessControl?.companyId}/availability`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar empresa',
    onSuccess,
  });
};

export default useEditCompanyAvailability;
